export default __webpack_public_path__ + "static/autism-connect-lg-625279918f45ba52e9fba1d1747d65f2.svg";